import Big from 'big.js';
import { createSelector } from '@reduxjs/toolkit';
import { StoreState } from '../../../app/app.reducers';

const AFTERNOON_CARE_ORIGINAL_PRICE = 79; // Euros

export const getSubmitEliteApplicationResponseState = (state: StoreState) =>
  state.elitetutor.submitEliteApplicationResponseState;

export const getSubjectApplicationContactUsModal = (state: StoreState) =>
  state.elitetutor.subjectApplicationContactUsModal;

export const getSubjectApplications = (state: StoreState) =>
  state.elitetutor.subjectApplicationsResponseState;

export const getVacancyList = (state: StoreState) =>
  state.elitetutor.vacancyListResponseState?.vacancies;

export const getVacancyBookingsList = (state: StoreState) =>
  state.elitetutor.vacancyListResponseState?.bookings;

export const getBookingList = (state: StoreState) =>
  state.elitetutor.bookingListResponseState.bookingListResponse;

export const getBookingListType = (state: StoreState) =>
  state.elitetutor.bookingListResponseState.type;

export const getBookingListViewAs = (state: StoreState) =>
  state.elitetutor.bookingListResponseState.viewAs;

export const getBookingListPayload = (state: StoreState) =>
  state.elitetutor.bookingListResponseState.payload;

export const getElitePaymentConfig = (state: StoreState) =>
  state.elitetutor.elitePaymentConfigResponseState;

export const getPersonalizedSubscriptionData = (state: StoreState) =>
  state.elitetutor.personalizedSubscriptionData;

export const getElitePaymentBestPriceList = (state: StoreState) => {
  const plans = state.elitetutor.elitePaymentConfigResponseState?.plans || [];
  const elitePlanBiannually = plans[0];

  return elitePlanBiannually?.tiers;
};

export const getElitePaymentRegularPrice = (state: StoreState) => {
  const plans = state.elitetutor.elitePaymentConfigResponseState?.plans || [];
  const elitePlanMonthly = plans[plans.length - 1];

  return elitePlanMonthly?.tiers[0]?.normalizedPrice;
};

export const getElitePaymentPlans = (state: StoreState) =>
  state.elitetutor.elitePaymentConfigResponseState?.plans;

export const getElitePaymentExamPrepPlan = (state: StoreState) =>
  state.elitetutor.elitePaymentConfigResponseState?.examPrep.plan;

export const getElitePaymentSla1Plan = (state: StoreState) =>
  state.elitetutor.elitePaymentConfigResponseState?.sla1.plan;

export const getElitePaymentSla2Plan = (state: StoreState) =>
  state.elitetutor.elitePaymentConfigResponseState?.sla2.plan;

export const getElitePaymentSeekerInfo = (state: StoreState) =>
  state.elitetutor.elitePaymentSeekerInfoResponseState;

export const getHasLiveEliteSeekerSubscription = (state: StoreState) => {
  const liveSubscriptionCount = state.authentication.user?.liveEliteseekerSubscriptionCount;

  return liveSubscriptionCount == null ? null : liveSubscriptionCount > 0;
};

export const getEliteseekerCreditEventList = (state: StoreState) =>
  state.elitetutor.eliteseekerCreditEventListResponseState?.results;

export const getElitetutorCreditEventList = (state: StoreState) =>
  state.elitetutor.elitetutorCreditEventListResponseState.creditEventListResponse?.results;

export const getElitetutorCreditEventTotalCount = (state: StoreState) =>
  state.elitetutor.elitetutorCreditEventListResponseState.creditEventListResponse?.totalCount;

export const getElitetutorCreditEventPreset = (state: StoreState) =>
  state.elitetutor.elitetutorCreditEventListResponseState.preset;

export const getElitetutorCreditEventPayload = (state: StoreState) =>
  state.elitetutor.elitetutorCreditEventListResponseState.payload;

export const getCreditTutor = (state: StoreState) => state.elitetutor.creditTutorResponseState;

export const getCanceledBooking = (state: StoreState) =>
  state.elitetutor.cancelBookingResponseState;

export const getSeekerSubscriptionChangeInfoPreview = (state: StoreState) =>
  state.elitetutor.seekerSubscriptionChangeInfoPreviewResponseState;

export const getElitepaymentCreditPurchase = (state: StoreState) =>
  state.elitetutor.elitepaymentCreditPurchaseResponseState;

export const getBookingCreditInsufficientInfo = (state: StoreState) =>
  state.elitetutor.bookingCreditInsufficientInfo;

export const getEliteratings = (state: StoreState) => state.elitetutor.eliteratingResponseState;
export const getOpenEliteratings = (state: StoreState) =>
  state.elitetutor.eliteratingResponseState.filter((rating) => rating.status === 'open');

export const getActiveBanner = (state: StoreState) => state.elitetutor.activeBanner;

export const getPricingFormValues = (state: StoreState) => state.elitetutor.pricingFormValues;
export const getPaymentFormValues = (state: StoreState) => state.elitetutor.paymentFormValues;
export const getSubscriptionIntentResponse = (state: StoreState) =>
  state.elitetutor.subscriptionIntentResponseState;

export const getSubscriptionCreateContext = (state: StoreState) =>
  state.elitetutor.subscriptionCreateContextState;

export const getAfternoonCarePricing = createSelector([getElitePaymentConfig], (config) => {
  const item = config?.afternoonCare;
  const price = item?.price.unitAmount;

  if (price == null) {
    return {
      isAvailable: false,
      price: null,
      currency: null,
      originalPrice: null,
      dailyPrice: null,
      discountPercentage: null,
    };
  }

  return {
    isAvailable: !!config?.active,
    price,
    currency: item?.price.currency,
    originalPrice: AFTERNOON_CARE_ORIGINAL_PRICE,
    dailyPrice: new Big(price).div(20).round(1, Big.roundUp).toNumber(),
    discountPercentage: new Big(AFTERNOON_CARE_ORIGINAL_PRICE)
      .minus(price)
      .div(AFTERNOON_CARE_ORIGINAL_PRICE)
      .times(100)
      .round(0, Big.roundDown)
      .toNumber(),
  };
});
